/**
 * Product Drawer ("pd-")
 * Slide-in side panel for product detail sections (Size & Fit, Materials, etc),
 * modelled on the Toteme product page pattern. Self-contained: does not depend
 * on the theme's built-in accordion/tab JS.
 *
 * Added for THE CURATED.
 */
(function () {
  'use strict';

  function initDrawer(root) {
    // Move the drawer to a direct child of <body>. Otherwise an ancestor
    // element that establishes its own stacking context (e.g. the theme's
    // fixed header, which uses its own z-index scope) can render above the
    // drawer even though the drawer's z-index is numerically higher.
    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    var overlay = root.querySelector('.pd-overlay');
    var panel = root.querySelector('.pd-panel');
    var closeBtn = root.querySelector('.pd-panel__close');
    var navItems = Array.prototype.slice.call(root.querySelectorAll('.pd-panel__nav-item'));
    var panes = Array.prototype.slice.call(root.querySelectorAll('.pd-pane'));
    var triggers = Array.prototype.slice.call(
      document.querySelectorAll('[data-pd-trigger][data-pd-root="' + root.id + '"]')
    );
    var lastFocused = null;

    function setActive(target) {
      navItems.forEach(function (item) {
        item.classList.toggle('is-active', item.getAttribute('data-pd-nav') === target);
      });
      panes.forEach(function (pane) {
        pane.classList.toggle('is-active', pane.getAttribute('data-pd-pane') === target);
      });
    }

    function open(target) {
      lastFocused = document.activeElement;
      if (target) setActive(target);
      root.classList.add('is-open');
      document.documentElement.classList.add('pd-lock-scroll');
      window.setTimeout(function () {
        if (closeBtn) closeBtn.focus();
      }, 50);
    }

    function close() {
      root.classList.remove('is-open');
      document.documentElement.classList.remove('pd-lock-scroll');
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        open(trigger.getAttribute('data-pd-trigger'));
      });
    });

    navItems.forEach(function (item) {
      item.addEventListener('click', function () {
        setActive(item.getAttribute('data-pd-nav'));
      });
    });

    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        close();
      }
    });
  }

  function init() {
    var roots = document.querySelectorAll('[data-pd-root-el]');
    roots.forEach(initDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
